import { FETCH_STCK_PO_PRINT_JOB_LIST, RECEIVE_STCK_PO_PRINT_JOB_LIST, FAILED_STCK_PO_PRINT_JOB_LIST } from '../../actions/stocker/stck.poprintjob.act'

const defaultStckPoPrintJobState = {
    stckPoPrintJobData: [],
    stckTotalPoPrintJob: 0,
    stckPoPrintJobSelect: [],
    success: true,
    inProgress: false,
}

export function StckPoPrintJob(state = defaultStckPoPrintJobState, action){
    switch (action.type) {
        case FETCH_STCK_PO_PRINT_JOB_LIST:
            return ({stckPoPrintJobData: [], success: true, stckTotalPoPrintJob: 0, stckPoPrintJobSelect: [], inProgress: true})
        case RECEIVE_STCK_PO_PRINT_JOB_LIST:
            var _totalPoPrintJob = action.payload.result.length;
            var _stckPoPrintJobSelect = []
            // if(action.payload.result !== []) {
            //     var _poApprovalData = action.payload.result

            //     _poApprovalData.forEach((p, index) => {
            //         var _loc = {
            //             'label': _poApprovalData[index].po_type_name + ' (' + _poApprovalData[index].po_type_desc + ')',
            //             'value': _poApprovalData[index].id,"id": 1,
            //             "id_company": 1,
            //             "id_purchase_order": 1,
            //             "po_number": "PO0001",
            //             "po_creation_date": "2021-10-15 21:00:00",
            //             "po_due_date": "2021-12-15 21:00:00",
            //             "id_po_rule": 1,
            //             "limit_po_value": 10,
            //             "step_count": 10,
            //             "id_user_approval": 122,
            //             "id_division": 1,
            //             "division_name": "",
            //             "remark": ""
            //         }
            //         _stckPoPrintJobSelect.push(_loc)
            //     })
            // }
            return Object.assign({}, state, {stckPoPrintJobData: action.payload, success: true, stckTotalPoPrintJob: _totalPoPrintJob, stckPoPrintJobSelect: _stckPoPrintJobSelect, inProgress: false})
        case FAILED_STCK_PO_PRINT_JOB_LIST:
            return ({stckPoPrintJobData: [], success: false, stckTotalPoPrintJob: 0, stckPoPrintJobSelect: [], inProgress: false})
        default:
            return state
    }
}